import { OperationVars } from "@/types/operation";

const toVariableReducer = <T>(result: OperationVars<T>, item: keyof T) => {
  result[item] = `$${String(item)}`;
  return result;
};

export default toVariableReducer;
